// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container {
  background-color: #ffffff;
}
.notification-container .notification {
  color: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1254901961);
  opacity: 0.75;
}
.notification-container .notification:last-child {
  border: none;
}
.notification-container .notification.notification-unread {
  opacity: 1;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/index/notifications.component.scss"],"names":[],"mappings":"AAAA;EACG,yBAAA;AACH;AAAE;EACE,cAAA;EACA,oDAAA;EAIA,aAAA;AADJ;AAFI;EACE,YAAA;AAIN;AADI;EACE,UAAA;EACA,iBAAA;AAGN","sourcesContent":[".notification-container {\n   background-color: #ffffff;\n  .notification {\n    color: #000000;\n    border-bottom: 1px solid #00000020;\n    &:last-child {\n      border: none;\n    }\n    opacity: 0.75;\n    &.notification-unread {\n      opacity: 1;\n      font-weight: bold;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
